// extracted by mini-css-extract-plugin
export default {"enterCode":"_3AFoX","forgotPassword":"_1F_4d","inputList":"_3MX33","passwordInput":"SQKeg"};